import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertPartsDeliveryRequestMutationVariables = Types.Exact<{
  object: Types.Parts_Deliveries_Insert_Input;
}>;


export type InsertPartsDeliveryRequestMutation = { __typename?: 'mutation_root', insert_parts_deliveries_one?: { __typename?: 'parts_deliveries', id: number, orchestration_status: string } | null };

export type LinkRunPartsDeliveryMutationVariables = Types.Exact<{
  runId: Types.Scalars['bigint']['input'];
  partsDeliveryId: Types.Scalars['bigint']['input'];
}>;


export type LinkRunPartsDeliveryMutation = { __typename?: 'mutation_root', update_mobility_runs_by_pk?: { __typename?: 'mobility_runs', id: number, parts_delivery_id?: number | null } | null };


export const InsertPartsDeliveryRequestDocument = gql`
    mutation insertPartsDeliveryRequest($object: parts_deliveries_insert_input!) {
  insert_parts_deliveries_one(object: $object) {
    id
    orchestration_status
  }
}
    `;
export type InsertPartsDeliveryRequestMutationFn = Apollo.MutationFunction<InsertPartsDeliveryRequestMutation, InsertPartsDeliveryRequestMutationVariables>;

/**
 * __useInsertPartsDeliveryRequestMutation__
 *
 * To run a mutation, you first call `useInsertPartsDeliveryRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPartsDeliveryRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPartsDeliveryRequestMutation, { data, loading, error }] = useInsertPartsDeliveryRequestMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertPartsDeliveryRequestMutation(baseOptions?: Apollo.MutationHookOptions<InsertPartsDeliveryRequestMutation, InsertPartsDeliveryRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPartsDeliveryRequestMutation, InsertPartsDeliveryRequestMutationVariables>(InsertPartsDeliveryRequestDocument, options);
      }
export type InsertPartsDeliveryRequestMutationHookResult = ReturnType<typeof useInsertPartsDeliveryRequestMutation>;
export type InsertPartsDeliveryRequestMutationResult = Apollo.MutationResult<InsertPartsDeliveryRequestMutation>;
export type InsertPartsDeliveryRequestMutationOptions = Apollo.BaseMutationOptions<InsertPartsDeliveryRequestMutation, InsertPartsDeliveryRequestMutationVariables>;
export const LinkRunPartsDeliveryDocument = gql`
    mutation linkRunPartsDelivery($runId: bigint!, $partsDeliveryId: bigint!) {
  update_mobility_runs_by_pk(
    pk_columns: {id: $runId}
    _set: {parts_delivery_id: $partsDeliveryId}
  ) {
    id
    parts_delivery_id
  }
}
    `;
export type LinkRunPartsDeliveryMutationFn = Apollo.MutationFunction<LinkRunPartsDeliveryMutation, LinkRunPartsDeliveryMutationVariables>;

/**
 * __useLinkRunPartsDeliveryMutation__
 *
 * To run a mutation, you first call `useLinkRunPartsDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkRunPartsDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkRunPartsDeliveryMutation, { data, loading, error }] = useLinkRunPartsDeliveryMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *      partsDeliveryId: // value for 'partsDeliveryId'
 *   },
 * });
 */
export function useLinkRunPartsDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<LinkRunPartsDeliveryMutation, LinkRunPartsDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkRunPartsDeliveryMutation, LinkRunPartsDeliveryMutationVariables>(LinkRunPartsDeliveryDocument, options);
      }
export type LinkRunPartsDeliveryMutationHookResult = ReturnType<typeof useLinkRunPartsDeliveryMutation>;
export type LinkRunPartsDeliveryMutationResult = Apollo.MutationResult<LinkRunPartsDeliveryMutation>;
export type LinkRunPartsDeliveryMutationOptions = Apollo.BaseMutationOptions<LinkRunPartsDeliveryMutation, LinkRunPartsDeliveryMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/insertPartsDeliveryRequest.mutation.gql}
 */
export async function insertPartsDeliveryRequest(
  variables: InsertPartsDeliveryRequestMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertPartsDeliveryRequestMutation['insert_parts_deliveries_one']>
export async function insertPartsDeliveryRequest(
  variables: InsertPartsDeliveryRequestMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertPartsDeliveryRequestMutation>
export async function insertPartsDeliveryRequest(
  variables: InsertPartsDeliveryRequestMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertPartsDeliveryRequestMutation['insert_parts_deliveries_one'] | InsertPartsDeliveryRequestMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertPartsDeliveryRequestMutation>(
    InsertPartsDeliveryRequestDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_parts_deliveries_one
}

/**
 * @source {@link src/features/partsDelivery/queries/insertPartsDeliveryRequest.mutation.gql}
 */
export async function linkRunPartsDelivery(
  variables: LinkRunPartsDeliveryMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<LinkRunPartsDeliveryMutation['update_mobility_runs_by_pk']>
export async function linkRunPartsDelivery(
  variables: LinkRunPartsDeliveryMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<LinkRunPartsDeliveryMutation>
export async function linkRunPartsDelivery(
  variables: LinkRunPartsDeliveryMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<LinkRunPartsDeliveryMutation['update_mobility_runs_by_pk'] | LinkRunPartsDeliveryMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<LinkRunPartsDeliveryMutation>(
    LinkRunPartsDeliveryDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_mobility_runs_by_pk
}